/**
 * เพลงหมู่เงาจันทร์ (chorus): its lock routine (design docs/design/combat/2026-10-11-lock-moves-13.md §2.5, kit audit
 * docs/design/combat/2026-10-13-art-kit-audit.md piece 6). The lock move is dd-sleeve 袖 (range 2.4, the 0.35 s lock wind-up:
 * both arms swept back, the long sleeves trailing out to full length, hips cocked). Identity: it works at sleeve length
 * (`spacing` [2.0, 2.4], not the sword-length band), the foe is spun like a top by cloth, and the beats shorten as it goes
 * (0.8 → 0.6 → 0.5 s: tempo is the identity). Every lash carries dd-sleeve's poison (the move's `applies`). Contrast: the
 * listening-blade partner dance is at touching distance and slow-then-sudden. Keys (dd* poses, silk/poison fx, silk/whip sfx with
 * rising pitch) are the contract for the motion / FX / sound lanes. Data only.
 */
import { registerLongMove } from './registry';

/** 袖 แพรพันลูกข่าง — the sleeves wrap, the foe spun three times faster, four lashes, a helix leap, the drop strike. */
export const SILK_TOP = registerLongMove({
  skillId: 'dd-sleeve',
  kind: 'lock',
  name: 'แพรพันลูกข่าง',
  opener: { type: 'contact', range: 0, tell: 0 },
  len: 5.4,
  catch: 0.45,
  power: 2.4,
  lunge: 0.4,
  spacing: [2.0, 2.4],
  beats: [
    { at: 0, pose: 'ddWrap', hits: 0, share: 0, foe: 'hit', fx: 'silkBind', sfx: 'silkSnap', cam: 'hold' },
    { at: 0.45, pose: 'ddWind1', hits: 1, share: 0.08, foe: 'spin', ai: 2, fx: 'silkSpiral', sfx: 'silkWhirl', cam: 'orbit' },
    { at: 1.25, pose: 'ddWind2', hits: 1, share: 0.08, foe: 'spin', ai: 3, fx: 'silkSpiral', sfx: 'silkWhirl2', cam: 'orbit' },
    { at: 1.85, pose: 'ddWind3', hits: 2, share: 0.12, foe: 'spin', ai: 4, fx: 'silkSpiral', sfx: 'silkWhirl3', cam: 'orbit' },
    { at: 2.35, pose: 'ddLashes', hits: 4, share: 0.24, foe: 'hit', fx: 'sleeveWhip', sfx: 'whipCrack4' },
    { at: 3.15, pose: 'ddHelixLeap', hits: 0, share: 0, foe: 'hit', fx: 'silkHelix', sfx: 'clothWhirl', cam: 'push' },
    {
      at: 3.7,
      pose: 'ddDropStrike',
      hits: 1,
      share: 0.48,
      foe: 'knock',
      dist: 1.0,
      stop: 0.08,
      fx: 'poisonBloom',
      sfx: 'silkThud',
      cam: 'shake',
    },
    { at: 4.3, pose: 'ddLand', hits: 0, share: 0, foe: 'fall' },
    { at: 4.9, pose: 'ddStance', hits: 0, share: 0, foe: 'recover' },
  ],
});
